import {PropsWithChildren, ReactNode, useCallback} from "react";
import {useDispatch} from "react-redux";

import {isFetchBaseQueryError} from "@pg-mono/react-hook-forms-utils";
import {IUserPhoneVerificationContextValue, UserPhoneVerificationContext} from "@pg-mono/user";
import {CONSULTANT_PHONE_NATIONAL} from "@pg-rp/consultants";

import {addNotification} from "../../notifications/state/notifications_slice";
import {defaultAPIErrorNotification} from "../../notifications/utils/error_notifications";
import {setAmplitudePhoneVerifiedUserProperty} from "../../tracking/amplitude/set_amplitude_phone_verified_user_property";
import {useGetUserProfileQuery} from "../api/user_api";
import {usePostUserPhoneVerificationCodeMutation, usePostUserPhoneVerifyMutation} from "../api/user_api";

export const UserPhoneVerificationProvider = (props: PropsWithChildren) => {
    const {children} = props;
    const dispatch = useDispatch();
    const {data: userInfo} = useGetUserProfileQuery();
    const [sendPhoneVerificationCode] = usePostUserPhoneVerificationCodeMutation();
    const [postUserPhoneVerify] = usePostUserPhoneVerifyMutation();

    const getUserProfile = useCallback(async () => {
        if (!userInfo) {
            return null;
        }
        return userInfo;
    }, [userInfo]);

    const handleSendPhoneVerificationCode = useCallback(async () => {
        try {
            await sendPhoneVerificationCode().unwrap();
            return {};
        } catch (error) {
            if (isFetchBaseQueryError(error)) {
                const errorData = error.data as {error?: string} | undefined;
                const message = errorData?.error || "Wystąpił błąd podczas wysyłania kodu";
                return {error: {message, status: error.status as number}};
            }
            dispatch(addNotification(defaultAPIErrorNotification));
            return {error: {message: "Wystąpił błąd podczas wysyłania kodu", status: 500}};
        }
    }, [sendPhoneVerificationCode, dispatch]);

    const handleVerifyPhone = useCallback(
        async (code: string) => {
            try {
                await postUserPhoneVerify({verification_code: code}).unwrap();
                return {};
            } catch (error) {
                setAmplitudePhoneVerifiedUserProperty(false);

                if (isFetchBaseQueryError(error)) {
                    const errorData = error.data as {error?: string} | undefined;
                    const message = errorData?.error || "Wystąpił błąd podczas weryfikacji";
                    return {error: {message, status: error.status as number}};
                }
                dispatch(addNotification(defaultAPIErrorNotification));
                return {error: {message: "Wystąpił błąd podczas weryfikacji", status: 500}};
            }
        },
        [postUserPhoneVerify, dispatch]
    );

    const contextValue: IUserPhoneVerificationContextValue = {
        getUserProfile,
        sendPhoneVerificationCode: handleSendPhoneVerificationCode,
        verifyPhone: handleVerifyPhone,
        hotlinePhoneNumber: CONSULTANT_PHONE_NATIONAL
    };

    return <UserPhoneVerificationContext.Provider value={contextValue}>{children}</UserPhoneVerificationContext.Provider>;
};
import {PropsWithChildren, ReactNode, useCallback} from "react";
import {useDispatch} from "react-redux";

import {isFetchBaseQueryError} from "@pg-mono/react-hook-forms-utils";
import {IUserPhoneVerificationContextValue, UserPhoneVerificationContext} from "@pg-mono/user";
import {CONSULTANT_PHONE_NATIONAL} from "@pg-rp/consultants";

import {addNotification} from "../../notifications/state/notifications_slice";
import {defaultAPIErrorNotification} from "../../notifications/utils/error_notifications";
import {setAmplitudePhoneVerifiedUserProperty} from "../../tracking/amplitude/set_amplitude_phone_verified_user_property";
import {useGetUserProfileQuery} from "../api/user_api";
import {usePostUserPhoneVerificationCodeMutation, usePostUserPhoneVerifyMutation} from "../api/user_api";

export const UserPhoneVerificationProvider = (props: PropsWithChildren) => {
    const {children} = props;
    const dispatch = useDispatch();
    const {data: userInfo} = useGetUserProfileQuery();
    const [sendPhoneVerificationCode] = usePostUserPhoneVerificationCodeMutation();
    const [postUserPhoneVerify] = usePostUserPhoneVerifyMutation();

    const getUserProfile = useCallback(async () => {
        if (!userInfo) {
            return null;
        }
        return userInfo;
    }, [userInfo]);

    const handleSendPhoneVerificationCode = useCallback(async () => {
        try {
            await sendPhoneVerificationCode().unwrap();
            return {};
        } catch (error) {
            if (isFetchBaseQueryError(error)) {
                const errorData = error.data as {error?: string} | undefined;
                const message = errorData?.error || "Wystąpił błąd podczas wysyłania kodu";
                return {error: {message, status: error.status as number}};
            }
            dispatch(addNotification(defaultAPIErrorNotification));
            return {error: {message: "Wystąpił błąd podczas wysyłania kodu", status: 500}};
        }
    }, [sendPhoneVerificationCode, dispatch]);

    const handleVerifyPhone = useCallback(
        async (code: string) => {
            try {
                await postUserPhoneVerify({verification_code: code}).unwrap();
                return {};
            } catch (error) {
                setAmplitudePhoneVerifiedUserProperty(false);

                if (isFetchBaseQueryError(error)) {
                    const errorData = error.data as {error?: string} | undefined;
                    const message = errorData?.error || "Wystąpił błąd podczas weryfikacji";
                    return {error: {message, status: error.status as number}};
                }
                dispatch(addNotification(defaultAPIErrorNotification));
                return {error: {message: "Wystąpił błąd podczas weryfikacji", status: 500}};
            }
        },
        [postUserPhoneVerify, dispatch]
    );

    const contextValue: IUserPhoneVerificationContextValue = {
        getUserProfile,
        sendPhoneVerificationCode: handleSendPhoneVerificationCode,
        verifyPhone: handleVerifyPhone,
        hotlinePhoneNumber: CONSULTANT_PHONE_NATIONAL
    };

    return <UserPhoneVerificationContext.Provider value={contextValue}>{children}</UserPhoneVerificationContext.Provider>;
};
